module.exports = __webpack_public_path__ + "img/card_260730946.4de86da3.png";